var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chatbot-button-wrapper"
  }, [_c('b-button', {
    staticClass: "chatbot-button",
    attrs: {
      "variant": "primary",
      "aria-label": _vm.$t('sheet.chatbot.open').toString(),
      "title": _vm.$t('sheet.chatbot.open').toString()
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('img', {
    staticClass: "chatbot-button__icon",
    attrs: {
      "src": require("@/assets/sheet/chatbot-icon-white.svg"),
      "alt": ""
    }
  })])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }